var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-circular',{attrs:{"rotate":-90,"size":_vm.progressSize,"width":_vm.progressWidth,"value":_vm.value,"color":"primary"}},[_c('span',{staticClass:"text--secondary text-small"},[_vm._v(_vm._s(_vm.textInside))])]),_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }